export const LocalStorageKeys = Object.freeze({
  AUTH_INFO: 'AUTH_INFO',
  SUPPORT_LAYER: 'SUPPORT_LAYER',
  SUPPORT_LAYER_PERSONA_TOKEN: 'SUPPORT_LAYER_PERSONA_TOKEN',
});
